/**
 * Created by rathompson on 6/10/22
 * File: utils
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useRef, useCallback } from 'react'

export const useGetLatest = (obj) => {
  const ref = useRef()
  ref.current = obj

  return useCallback(() => ref.current, [])
}

export const useAsyncDebounce = (defaultFn, defaultWait = 0) => {
  const debounceRef = useRef({})

  const getDefaultFn = useGetLatest(defaultFn)
  const getDefaultWait = useGetLatest(defaultWait)

  return useCallback(
    async (...args) => {
      if (!debounceRef.current.promise) {
        debounceRef.current.promise = new Promise((resolve, reject) => {
          debounceRef.current.resolve = resolve
          debounceRef.current.reject = reject
        })
      }

      if (debounceRef.current.timeout) {
        clearTimeout(debounceRef.current.timeout)
      }

      debounceRef.current.timeout = setTimeout(async () => {
        delete debounceRef.current.timeout
        try {
          debounceRef.current.resolve(await getDefaultFn()(...args))
        }
        catch (err) {
          debounceRef.current.reject(err)
        }
        finally {
          delete debounceRef.current.promise
        }
      }, getDefaultWait())

      return debounceRef.current.promise
    },
    [getDefaultFn, getDefaultWait]
  )
}
